import React from 'react'
import AdmFeeLedger from '../../components/AdminTabs/AdminFeeLedger/AdmFeeLedger'

const FeeLedger = () => {
  return (
    <div>
      <AdmFeeLedger/>
    </div>
  )
}

export default FeeLedger
